/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import { Breadcrumb, BreadcrumbItem, Col, Container, Hero, HeroBackground, Spinner, Card, CardBody, CardTitle, CardText, Icon, Row, CardReadMore } from 'design-react-kit';
import React, { useState, useEffect, useContext } from 'react';
import authApiService from 'pa_kit/services/api';
import ApiService from '../../../services/api';
import { TagClass } from 'pa_kit/apps/tags/models/tag';
import { useParams } from 'react-router-dom';
import Page404 from 'apps/pages/page404';
import { WidgetClass } from 'apps/pages/models/widget';
import WidgetNews from 'apps/news/components/widget_news';
import WidgetPageRating from 'pa_kit/apps/page_evaluation/components/widget_page_rating';
import WidgetContacts from 'pa_kit/apps/contacts/components/widget_contacts';
import parse from 'html-react-parser';
import WidgetEvent from 'apps/events/components/widget_event';
import WidgetPlace from 'apps/places/components/widget_place';
import WidgetDocuments from 'apps/documents/components/widget_documents';
import WidgetServices from 'apps/services/components/widget_services';
import Pagination from 'pa_kit/pagination';
import env from '../../../env';
import { ActaAuthContext } from "pa_kit/auth";
import { Helmet } from "react-helmet-async";


const MandatorySectionsList = (props) => {

    const id_section = props.section.id;

    let listContent;

    switch(id_section) {
        case 2:  // Documenti e dati         
            listContent = <DocumentsList tag={props.tag} />
            break;

        case 3: // Novità           
            listContent = <NewsList tag={props.tag} />
            break;

        case 4: // Servizi           
            listContent = <ServicesList tag={props.tag} />
            break;

        case 7: // Eventi           
            listContent = <EventsList tag={props.tag} />
            break;

        case 8: // Luoghi           
            listContent = <PlaceList tag={props.tag} />
            break;

        default:
            listContent = ''
    }

    return listContent;
}

const NewsList = (props) => {

    const id_tag = props.tag.id;

    const [ widgetNewsByTags ] = useState(new WidgetClass({
        name: "NewsByTags",
        class: "news-by-tags",
        id_tag: id_tag,
        show_number: 6,
        label: <span></span>
    }));

    return <>
        <WidgetNews widget={widgetNewsByTags} page={"tag"} />        
    </>
}

const EventsList = (props) => {

    const id_tag = props.tag.id;

    const [ widgetEventsByTags ] = useState(new WidgetClass({
        name: "EventsByTags",
        class: "events-by-tags",
        id_tag: id_tag,
        show_number: 6,
        label: <span></span>
    }));

    return <>
        <WidgetEvent widget={widgetEventsByTags} page={"tag"} />        
    </>
}

const PlaceList = (props) => {

    const id_tag = props.tag.id;

    const [ widgetPlacesByTags ] = useState(new WidgetClass({
        name: "PlacesByTags",
        class: "places-by-tags",
        id_tag: id_tag,
        label: <span></span>
    }));

    return <>
        <WidgetPlace widget={widgetPlacesByTags} page={"tag"} />        
    </>
}

const DocumentsList = (props) => {

    const id_tag = props.tag.id;

    const [ widgetDocumentsByTags ] = useState(new WidgetClass({
        name: "DocumentsCategoryRow",
        class: "documents-category-row",
        id_tag: id_tag,
        show_number: 12,
        label: <span></span>
    }));

    return <>
        <WidgetDocuments widget={widgetDocumentsByTags} page={"tag"} />        
    </>
}

const ServicesList = (props) => {

    const id_tag = props.tag.id;
    const tag_slug = props.tag.slug;

    const [ widgetServicesByTags ] = useState(new WidgetClass({
        name: "ServicesByTags",
        class: "services-by-tags",
        id_tag: id_tag,
        tag_slug: tag_slug,
        show_number: 12,
        label: <span></span>
    }));

    return <>
        <WidgetServices widget={widgetServicesByTags} page={"tag"} />                
    </>
}

const MainSectionsList = (props) => {

    const id_tag = props.tag.id;
    const id_section = props.section.id;

    const [ pageList, setPageList ] = useState();
    const [ currentPages, setCurrentPages ] = useState();
    const [ isLoading, setIsLoading ] = useState(true);

    const [ paginationState, setPaginationState ] = useState({
        currentPage: 1,
        pagesPerPage: 6
    });

    const handlePageChange = (pageNumber) => {
        setPaginationState({ ...paginationState, currentPage: pageNumber });
    };

    const fetchPageList = async() => {
        let pageListData;

        if(!pageList) {

            pageListData = await ApiService.getPages();
            pageListData = pageListData.filter(page => page.tags.some(tag => tag.id === id_tag));
            pageListData = pageListData.filter(page => page.main_section.id === id_section);

            setPageList(pageListData);
            setIsLoading(false);
        } else {
            pageListData = pageList;
        }
        
        const indexOfLastElement = paginationState.currentPage * paginationState.pagesPerPage;
        const indexOfFirstElement = indexOfLastElement - paginationState.pagesPerPage;
        const currentPages = pageListData.slice(indexOfFirstElement, indexOfLastElement);
        setCurrentPages(currentPages);
    }

    useEffect(() => {
        fetchPageList();
    }, [paginationState]);

    if(isLoading) return <Container className="p-5"><Spinner active /></Container>
    if(pageList && pageList.length === 0) return <></>;
    return <>
        <Container className="mt-5 pt-5">
            <h2 className="news-by-tags-title mb-4 px-1">{props.section.name}</h2>  
        </Container>
        <Container>
            <Row id={"pages" + id_section + "-elements-wrapper"}>
            {currentPages && currentPages.map((page) => 
                <Col xs='12' lg='4' className="mt-4" key={"key_pageItem_" + page.id}>                    
                    <Card className="news-card border border-light shadow-sm">
                        <CardBody>
                            <CardTitle tag='h3' className='big-heading'>
                                <a href={'/' + page.slug + '/'} className="text-decoration-none me-2" title={page.title}>{page.title}</a>
                            </CardTitle>
                            <CardText>
                                {page.meta_description}
                            </CardText>
                            <CardReadMore href={'/' + page.slug + '/'} text='Vai alla pagina' iconName='it-arrow-right' />
                        </CardBody>
                    </Card>
                </Col>
            )}
            </Row>
            <Pagination
                elementsPerPage={paginationState.pagesPerPage}
                totalElements={pageList && pageList.length}
                currentPage={paginationState.currentPage}
                onPageChange={handlePageChange}
                type={"pages" + id_section}
            /> 
        </Container>
    </>  
}

const PageList = (props) => {

    const id_tag = props.tag.id;

    const [ mainPageList, setMainPageList ] = useState();
    const [ isLoading, setIsLoading ] = useState(true);

    const fetchPageList = async() => {
        const pageListData = await ApiService.getPages();
        const pageListByTag = pageListData.filter(page => page.tags.some(tag => tag.id === id_tag));
        const mainPageList = pageListByTag.filter(page => page.main_section === '');
        setMainPageList(mainPageList);
        setIsLoading(false);
    }

    useEffect(() => {
        fetchPageList();
    }, []);

    if(isLoading || mainPageList.length === 0) return <div></div>;
    return <>
        <Container fluid className="mb-5 pb-5 tags-main-pages-wrapper">
            <Container className="mt-5 pt-5">
                <h2 className="news-by-tags-title mb-4 px-1">In evidenza</h2>  
            </Container>
            <Container>
                <Row>
                {mainPageList && mainPageList.map((page) => 
                    <Col xs='12' lg='4' className="mt-4" key={"key_pageItem_" + page.id}>                    
                        <Card className='card-img no-after shadow-sm'>
                        {page.meta_img && page.meta_img !== '' &&
                            <div className='img-responsive-wrapper'>
                                <div className='img-responsive img-responsive-panoramic'>
                                    <figure className='img-wrapper'>
                                        <img alt="Immagine Pagina" className="img-fluid" src={env.BACKEND_BASE_URL + page.meta_img || ''} title={page.title} />
                                    </figure>
                                </div>
                            </div>
                        }   
                            <CardBody className="px-4">
                                <CardTitle tag='h3' className="big-heading"> <a className="news-title-link" href={'/' + page.slug + '/'}>{page.title}</a> </CardTitle>
                                <div className="mt-2 news-description mb-5">
                                    {page.meta_description}
                                </div>
                                <a className="read-more position-relative" href={'/' + page.slug + '/'}>Leggi di più <Icon icon="it-arrow-right" /></a>
                                <div className="mt-5">
                                {page.tags && page.tags.map((tag) => 
                                    <div key={tag.slug} className={"chip chip-simple chip-primary me-2"}>
                                        <a className="chip-label" href={"/argomenti/" + tag.slug + '/'}>{tag.name}</a>
                                    </div>
                                )} 
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                )}
                </Row>
            </Container>
        </Container>
    </>  
}

const PageTagsSingle = (props) => {

    const auth = useContext(ActaAuthContext);

    const organization = auth.organization;

    const { tagSlug } = useParams();

    const [ mandatoryMainSections, setMandatoryMainSections ] = useState({});
    const [ mainSections, setMainSections ] = useState({});

    const [ tag, setTag ] = useState();
    const [ isLoading, setIsLoading ] = useState(true);
    const [ sectionsLoading, setSectionsLoading ] = useState(true);
    const [ pageNotFound, setPageNotFound ] = useState(false);

    const fetchTag = async() => {
        try {
            const tagData = await authApiService.getTag(tagSlug);
            setTag(new TagClass(tagData));
            setIsLoading(false);
        } catch (error) {
            setPageNotFound(true);
        }       
    }

    const fetchMainSections = async() => {
        const mainSectionsData = await ApiService.getMainSections();
        const mandatoryMainSections = mainSectionsData.filter(main_section => (main_section.mandatory === true && main_section.is_active === true)); 
        const mainSections = mainSectionsData.filter(main_section => (main_section.mandatory === false && main_section.is_active === true)); 
        setMandatoryMainSections(mandatoryMainSections);
        setMainSections(mainSections);
        setSectionsLoading(false);
    }

    useEffect(() => {
        fetchTag();
        fetchMainSections();
    }, []);

    if(pageNotFound) return <Page404 />;
    if(isLoading || !tag || sectionsLoading) return <Container style={{ padding: "50px" }}><Spinner active /></Container>; 
    return <>
        <Helmet>
            <title>{tag.name + ' | ' + organization.name}</title>
            <meta name="description" content={(tag.description).substring(0, 255).replace(/(<([^>]+)>)/gi, "")} />
        </Helmet>
        <Container fluid className="p-0 tags-main-wrapper">
            <Hero overlap className="tag-hero-wrapper">
                {tag.image && <HeroBackground src={env.AUTH_BACKEND_BASE_URL + tag.image} title={tag.name} alt={tag.name} />}                
            </Hero>
            <Container>
                <Row>
                    <Col>
                        <Card spacing className='card-bg'>
                            <CardBody>
                                <Container>
                                    <Row>
                                        <Col>
                                            <Breadcrumb>
                                                <BreadcrumbItem>
                                                    <a href='/'>Home</a>
                                                    <span className='separator'>/</span>
                                                </BreadcrumbItem>
                                                <BreadcrumbItem>
                                                    <a href='/argomenti/'>Argomenti</a>
                                                    <span className='separator'>/</span>
                                                </BreadcrumbItem>
                                                <BreadcrumbItem>
                                                    {tag.name}
                                                </BreadcrumbItem>
                                            </Breadcrumb>
                                        </Col>
                                    </Row>
                                </Container>
                                
                                <Row>
                                    <Col lg="6"> 
                                        <CardTitle className='big-heading'>
                                            <h1>{tag.name}</h1>
                                        </CardTitle>                                       
                                        <div className="mt-4">{parse(tag.description)}</div>
                                    </Col>
                                    <Col lg={{size: 5, offset: 1}}>
                                    {tag && tag.office && <>
                                        <Row className="mt-4">                                            
                                            <Col>
                                                <p className="title-xsmall-semi-bold mb-1">Questo argomento è gestito da:</p>
                                            </Col>
                                        </Row> 
                                        <div className="tag-managedby-card">                                      
                                            <Row>
                                                <Col lg="8" xs="8">
                                                    <CardTitle tag='h5' className="mb-1">
                                                        <a href={'/' + tag.office.slug + '/'} title={tag.office.name}>{tag.office.name}</a>
                                                    </CardTitle>
                                                    <div className="card-description">
                                                        {(parse((tag.office.content.excerpt.description).substring(0, 100).replace(/(<([^>]+)>)/gi, "")) + (tag.office.content.excerpt.description.length > 100 ? '...' : ''))}
                                                    </div>
                                                    <a href={'/' + tag.office.slug + '/'} title="Vai all'ufficio" className="sticky-read-more read-more">VAI ALL'UFFICIO <Icon icon="it-arrow-right" /></a>
                                                </Col>
                                                <Col lg={{size: 3, offset: 1}} xs="4">
                                                    <Icon icon="it-pa" size="lg" />
                                                </Col>
                                            </Row>                    
                                        </div>
                                        </>
                                    }
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            
            <PageList tag={tag} />

            <Container className="mb-5">
                {mandatoryMainSections && mandatoryMainSections.map((section, index) => {
                    return <React.Fragment key={"key_mandatoryMainSection_" + index}>
                        {/* <Container className="mt-5 pt-5">
                            <h2 className="news-by-tags-title mb-4 px-1">{section.name}</h2>  
                        </Container> */}
                        <MandatorySectionsList tag={tag} section={section} />
                    </React.Fragment>
                })}

                {mainSections && mainSections.map((section, index) => {
                    return <React.Fragment key={"key_mainSection_" + index}>
                        {/* <Container className="mt-5 pt-5">
                            <h2 className="news-by-tags-title mb-4 px-1">{section.name}</h2>  
                        </Container> */}
                        <MainSectionsList tag={tag} section={section} />
                    </React.Fragment>
                })}

            </Container>

            <Container fluid className={'rating-wrapper page-rating tags-single-page-rating'} data-element="feedback">
                <WidgetPageRating page_title={tag.name}/>
            </Container>

            <Container fluid className={'contacts-wrapper tags-single-page-contacts'}>
                <WidgetContacts />
            </Container>

        </Container>       
    </>;
}

export default PageTagsSingle;